/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { NotificationDataEntryValue } from './notification-data-entry-value';
export class NotificationDataEntry {
  creationInfo?: ActionInfo;
  dataEntity: string;
  entityVersion?: number;
  id?: string;
  specificationVersion: number;
  state: 0 | 1 | 2;
  updateInfo?: ActionInfo;
  value: NotificationDataEntryValue;
}
